// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"4cbf9ee9","780":"bca94c3b"}[chunkId] + ".chunk.js";
};